document.addEventListener("DOMContentLoaded", function () {
  const couponCodeContainers = document.querySelectorAll(".coupon-code-part");
  couponCodeContainers.forEach(function(container) {
    const copyButton = container.querySelector(".copy-coupon-code");
    const couponCodeText = container.querySelector(".coupon-code-text").textContent;

    copyButton.addEventListener("click", function () {
      const tempInput = document.createElement("textarea");
      tempInput.value = couponCodeText;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      copyButton.textContent = "COPIED!";
      setTimeout(function () {
        copyButton.textContent = "COPY";
      }, 2000);
    });
  });
});

/* Test */
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".couponcode-wrapper").forEach(wrapper => {
        const couponText = wrapper.querySelector(".couponcode-text");
        const copyButton = wrapper.querySelector(".coupon-code-copy");

        copyButton.addEventListener("click", function () {
            // Copy the coupon code
            const couponCode = couponText.textContent.trim();
            const tempInput = document.createElement("input");
            document.body.appendChild(tempInput);
            tempInput.value = couponCode;
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);

            // Show the coupon code and change text to "Code Copied!"
            couponText.classList.remove("hidden");
            couponText.textContent = "Code Copied!";

            // Revert back to the original code after 3 seconds
            setTimeout(() => {
                couponText.textContent = couponCode;
                couponText.classList.add("hidden");
            }, 3000);
        });
    });
});